export default __webpack_public_path__ + "static/media/palace.c9a3c2c9.jpg";